<template>    
<div class="card border-0 mt-xl-5">
  <div class="card-body">

    <div class="row">
      <div class="col-12">

        <div v-if="loadingOrg == 0" class="row">
          <div class="col-12 d-flex justify-content-center align-items-center">
            <scaling-squares-spinner :animation-duration="2000" :size="45" color="#0E1698" style=""/>
            <span class="ml-3 h6" style="color:#0E1698">Loading Organization...</span>
          </div>
        </div>

        <div v-if="loadingOrg == 1" class="row">
          <div class="col-12 mb-2">
            <span class="text-muted">Name: </span>{{ orgDetails.name }}
          </div>
          <div class="col-12 mb-2">
            <span class="text-muted">Address Line 1: </span>{{ orgDetails.addr1 }}
          </div>
          <div v-if="orgDetails.addr2 != '' && orgDetails.addr2 != null" class="col-12 mb-2">
            <span class="text-muted">Address Line 2: </span>{{ orgDetails.addr2 }}
          </div>
          <div class="col-12 mb-2">
            <span class="text-muted">City: </span>{{ orgDetails.city }}
          </div>
          <div class="col-6 mb-2">
            <span class="text-muted">State: </span>{{ orgDetails.state }}
          </div>
          <div class="col-6 mb-2">
            <span class="text-muted">Zip: </span>{{ orgDetails.zip }}
          </div>
          <div class="col-12 mb-2">
            <span class="text-muted">Created: </span>{{ orgDetails.created_at | moment("dddd, MMMM Do YYYY") }}
          </div>
          <div class="col-12 mb-2">
            <span class="text-muted">Created By: </span>{{ orgDetails.creatorName }}
          </div>
          <div class="col-12 mb-4">
            <span class="text-muted">Last Modified: </span>{{ orgDetails.updated_at | moment("dddd, MMMM Do YYYY") }}
          </div>
          <div class="col-12">
            <button @click="cancelView" class="btn btn-primary">Close</button>
            <button @click="editOrg" class="btn btn-warning">Edit</button>
          </div>
        </div>

      </div>

    </div>

  </div>
</div>
</template>

<script>
import { ScalingSquaresSpinner } from 'epic-spinners'  
import {store} from '../../../stores/settings-user-main-store.js'

export default {
  store,
  props: ['prop1', 'prop2', 'prop3'],
  data: function () {
    return { 
      orgDetails: [],
      loadingOrg: 0,
    }
  },
  computed: {

  },
  watch: {
    prop1() { this.getOrgDetails(); },
    
  },
  mounted() {
    this.getOrgDetails();
  },
  methods: {
    getOrgDetails(){
      var _this = this;
      _this.loadingOrg = 0;
      axios.get('/utility/user/org/getorgdetails/' + _this.prop1)
        .then(function (response) {
          var a = response.data.data;
          _this.orgDetails = a;
          _this.loadingOrg = 1;
        });
    },
    cancelView() {
      var _this = this;
      _this.$emit('onUComplete', [ 'org-view' ])
    },
    editOrg() {
      var _this = this;
      _this.$emit('onSecondary', [ 'org-view', _this.orgDetails.id ])
    },
    errorDisplay(valErrors) {
      var _this = this;
      var errors = valErrors;
      var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
      $.each(errors, function(key, value){ errorsHTML += '<li>' + value + '</li>' });
      errorsHTML += '</ul></div>';
      _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
    },   
  },    
  components:{
    ScalingSquaresSpinner,
  },
  filters: {

  }
}
</script>
